import React, { Component } from "react";
import ReactEcharts from "echarts-for-react";
import NoRecord from "app/Components/CommanComponents/NoRecord";

function EchartFunnelChart(props) {
  let option = {
    tooltip: {

      formatter: (params) => {

        // console.log("BasicBarChartWithCustomToolTip", customToolTip[params?.name][0]?.fullName, customToolTip, params);
        // console.log("BasicBarChartWithCustomToolTip", params);
        return (
          `<div style="transform:rotate(180deg);">${params?.marker}${"&nbsp"}${params?.name} : ${params?.value}<br/></div>`

        );
      },
    },
    color: [
      "#90EE90",
      "#D2691E",
      "#6495ED",
      "#808000",
      "#DC143C",
    ],
    // emphasis: {
    //     label: {
    //         fontSize: 18,
    //         show: false
    //     }
    // },
    // grid: {
    //     top: '3%',
    //     left: '3%',
    //     right: '4%',
    //     bottom: '1%',
    //     containLabel: false
    // },
    // legend: {
    //     data: props.legend ? props.legend : [],
    //     type: 'scroll',
    // },
    legend: {
      data: ["Show", "Click", "Visit", "Inquiry", "Order"],
    },
    series: [
      {
        name: "Pyramid",
        type: "funnel",

        // top: 60,
        // bottom: 60,
        // width: '80%',
        // min: 0,
        // max: 100,
        // minSize: '0%',
        // maxSize: '100%',

        data: props.seriesData
          ? props.seriesData
          : [],
        sort: function (e) { },
      },
    ],
  };
  return (
    <React.Fragment>
      {Array.isArray(props.seriesData) && props.seriesData.length > 0 ? (
        <ReactEcharts
          style={{ height: props.height ? props.height : "515px", transform: "rotate(180deg)" }}
          option={option}
        />
      ) : (
        <NoRecord></NoRecord>
      )}
    </React.Fragment>
  );
}

export default EchartFunnelChart;
